import { hotkeyHint } from "@/hooks/useCoverageBetaHotkeys";
import { useCoverageBetaStore } from "@/store/useCoverageBetaStore";
import { ActionIcon, Text, Tooltip } from "@mantine/core";
import {
  IconEye,
  IconEyeOff,
  IconRefresh,
  IconZoomIn,
  IconZoomOut,
} from "@tabler/icons-react";
import { BrightnessControl } from "@/components/coverage-beta/BrightnessControl";
import { CursorMode } from "./cursor-mode/CursorMode";
import { DrawBoxMode } from "./draw-box-mode/DrawBoxMode";
import { DrawPersonMode } from "./draw-person-mode/DrawPersonMode";

const ICON_SIZE = 14;

export const QueryImageControlIcons = () => {
  const isReadOnly = useCoverageBetaStore((s) => s.isReadOnly);
  const showBoxes = useCoverageBetaStore((s) => s.showBoxes);
  const toggleBoxes = useCoverageBetaStore((s) => s.toggleBoxes);
  const recordInteraction = useCoverageBetaStore((s) => s.recordInteraction);
  const onZoomIn = () => {
    useCoverageBetaStore.getState().pinchRef?.zoomIn();
    recordInteraction("zoom_in", "click");
  };
  const onZoomOut = () => {
    useCoverageBetaStore.getState().pinchRef?.zoomOut();
    recordInteraction("zoom_out", "click");
  };
  const onResetView = () => {
    useCoverageBetaStore.getState().pinchRef?.resetTransform();
    recordInteraction("reset_view", "click");
  };

  return (
    <div className="border-b text-gray-500 font-semibold ">
      <div className="p-3">
        {/* Drawing tools are edit affordances — hidden in read-only (admin). */}
        {!isReadOnly && (
          <>
            <div>
              <div
                className="flex items-center gap-1"
                data-cb-tour="toolbar-classes"
              >
                <Text size="xs" c="dimmed" fw={600} className="text-center">
                  Classes
                </Text>

                <DrawBoxMode />

                <DrawPersonMode />
              </div>
            </div>

            <div className="h-2" />
          </>
        )}

        {/* Tools */}
        <div className="flex items-center gap-1" data-cb-tour="toolbar-tools">
          <Text size="xs" c="dimmed" fw={600} className="text-center " mr={4}>
            Tools
          </Text>

          <CursorMode />

          <Tooltip
            label={`Zoom In (${hotkeyHint("zoom_in")})`}
            position="right"
          >
            <ActionIcon
              size="sm"
              variant="light"
              color="gray"
              onClick={onZoomIn}
            >
              <IconZoomIn size={ICON_SIZE} />
            </ActionIcon>
          </Tooltip>

          <Tooltip
            label={`Zoom Out (${hotkeyHint("zoom_out")})`}
            position="right"
          >
            <ActionIcon
              size="sm"
              variant="light"
              color="gray"
              onClick={onZoomOut}
            >
              <IconZoomOut size={ICON_SIZE} />
            </ActionIcon>
          </Tooltip>
          <Tooltip
            label={`Reset View (${hotkeyHint("reset_view")})`}
            position="right"
          >
            <ActionIcon
              size="sm"
              variant="light"
              color="gray"
              onClick={onResetView}
            >
              <IconRefresh size={ICON_SIZE} />
            </ActionIcon>
          </Tooltip>
          <Tooltip
            label={
              showBoxes
                ? `Hide boxes (${hotkeyHint("toggle_boxes")})`
                : `Show boxes (${hotkeyHint("toggle_boxes")})`
            }
            position="right"
          >
            <ActionIcon
              size="sm"
              variant={showBoxes ? "light" : "filled"}
              color="gray"
              onClick={() => {
                toggleBoxes();
                recordInteraction("toggle_boxes", "click");
              }}
            >
              {showBoxes ? (
                <IconEye size={ICON_SIZE} />
              ) : (
                <IconEyeOff size={ICON_SIZE} />
              )}
            </ActionIcon>
          </Tooltip>

          <BrightnessControl view="query" position="right" />
        </div>
      </div>
    </div>
  );
};
